import { useCallback, useState } from 'react';

type LightBoxProps = JSX.IntrinsicElements['img'];

export const LightBox = ({ src, alt }: LightBoxProps) => {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => {
    setOpen((prevState) => !prevState);
  }, []);

  return (
    <div className='wrapper'>
      <div onClick={toggle}>
        <img alt={alt} src={src} />
      </div>

      {open ? (
        <div className='lightbox-main' onClick={toggle}>
          <img alt={alt} className='lightbox-image' src={src} />
        </div>
      ) : null}
    </div>
  );
};
